import { Box, Button, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import background from "../../assets/images/pwa-background.png"

export const DesktopButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.colors.primary.slalomBlue, 
  color: theme.palette.primary.contrastText, 
  width:"200px", 
  padding:"12px 20px"
}));

export const DesktopTextOnlyButton = styled(Button)(({ theme }) => ({
  "&:hover": {
        backgroundColor: "transparent"
  },
  "&:active": {
        backgroundColor: "none"
  }
}));

export const MobileSubtitleActionText = styled(Typography)(({ theme }) => ({
  cursor: "pointer",
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 0.7,
  },
  color: theme.colors.primary.slalomDarkBlue,
  display: "flex", 
  alignItems: "center", 
  fontFamily: 'Slalom Sans', 
  fontSize: "14px", 
  fontWeight: 400, 
  lineHeight: "16px"
}));

export const CloseModalButton = styled(IconButton)(({ theme }) => ({
  color: theme.colors.neutral.darkGray
}));

export const QRContainer = styled(Box)(() => ({
    backgroundImage: `url(${background})`,
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "100%",
    backgroundPosition: "center",
    borderRadius: "8px"
}));

export const QRCode = styled(Typography)(() => ({
    justifyContent: "center", 
    display: "flex", 
fontFamily: 'Slalom Sans', 
fontSize: "12px", 
fontWeight: 700, 
lineHeight: "20px", 
}));

export const DesktopBannerPrimaryText = styled(Typography)(() => ({
    fontFamily: "Slalom Sans",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "16px",
    paddingLeft: "8px"
}));

export const MobileBannerPrimaryText = styled(Typography)(() => ({
    fontFamily: "Slalom Sans",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "14px",
}));

export const DesktopSubtitleActionText = styled(Typography)(({ theme }) => ({
  cursor: "pointer",
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 0.7,
  },
  color: theme.colors.primary.slalomDarkBlue,
  display: "flex", 
  alignItems: "center", 
    fontFamily: 'Slalom Sans', 
  fontSize: "16px", 
  fontWeight: 400, 
  lineHeight: "16px", 
}));

export const BaseSubtitleActionText = styled(Typography)(({ theme }) => ({
  cursor: "pointer",
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 0.7,
  },
  color: theme.colors.primary.slalomDarkBlue,
  display: "flex", 
  alignItems: "center",
}));
